import { EMPTY_VALUE_PLACEHOLDER } from '../../../const/system';
import { FEATURES_SOURCE_MAP } from '../pages/PageFeatures/PageFeatures.const';
import { NEWS_DICT_STRUCTURE } from '../../Content/pages/News/PageDynamicNews/PageDynamicNews.const';
import { POPUPS_SOURCE } from '../../Other/pages/Popups/PagePopups/PagePopups.const';
import { COLLECTIONS_SOURCE } from '../../Content/pages/Collections/PageCollections/PageCollections.const';
import { LOCAL_NOTIFICATIONS_SOURCE } from '../../Other/pages/Notitications/Local/PageLocalNotifications/PageLocalNotifications.const';
import { PUSH_NOTIFICATIONS_SOURCE } from '../../Other/pages/Notitications/Push/PagePushNotifications/PagePushNotifications.const';
import { CATEGORIES_SOURCE } from '../../Content/pages/Categories/PageCategories/PageCategories.const';



const getFeatureSourceTranslation = (source) => {
  switch (source) {
    case FEATURES_SOURCE_MAP.DAILY: return 'features-breadcrumbs-daily';
    case FEATURES_SOURCE_MAP.EDITOR_CHOICE: return 'features-breadcrumbs-editors-choice';
    case FEATURES_SOURCE_MAP.EXTERNAL_PROMO: return 'features-breadcrumbs-external-promo';
    case NEWS_DICT_STRUCTURE: return 'dynamic-news-breadcrumbs';
    case POPUPS_SOURCE: return 'popups-breadcrumbs';
    case CATEGORIES_SOURCE: return 'categories-breadcrumbs';
    case COLLECTIONS_SOURCE: return 'collections-breadcrumbs';
    case LOCAL_NOTIFICATIONS_SOURCE: return 'local-notifications-breadcrumbs';
    case PUSH_NOTIFICATIONS_SOURCE: return 'push-notifications-breadcrumbs';

    default: return EMPTY_VALUE_PLACEHOLDER;
  }
};

export default getFeatureSourceTranslation;
